import { render, staticRenderFns } from "./keywords-aside.component.vue?vue&type=template&id=4e2d2153&scoped=true"
import script from "./keywords-aside.component.vue?vue&type=script&lang=ts"
export * from "./keywords-aside.component.vue?vue&type=script&lang=ts"
import style0 from "./keywords-aside.component.vue?vue&type=style&index=0&id=4e2d2153&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2d2153",
  null
  
)

export default component.exports